var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtnToggleCarousel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "13px",
    viewBox: "0 0 10 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "btnToggleCarousel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.00105794,6.0963832e-06 C6.00926448,8.55454187e-06 6.91809562,0.65451403 7.30342246,1.65808109 C7.6887493,2.66164815 7.47461226,3.81644333 6.76094376,4.58355243 C6.04727527,5.35066153 4.974761,5.57886411 4.04391669,5.1616637 C3.11307239,4.7444633 2.50739567,3.76410274 2.50954079,2.67809192 C2.50953929,1.96682894 2.77220672,1.28478053 3.23960983,0.782377549 C3.70701295,0.279974565 4.34075445,-0.00151045583 5.00105794,6.0963832e-06 Z M0.0127225314,12.1970025 C0.0127225314,12.1970025 -0.517387502,6.41256554 5.26611296,6.60671249 C5.26611296,6.60671249 10.0052967,6.12134512 9.99999556,12.1970025 C7.75105899,12.7323342 6.08439454,13 5.00000222,13 C3.86499955,13 2.20257299,12.7323342 0.0127225314,12.1970025 Z",
    id: "btnToggleCarousel",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnToggleCarousel);
export default __webpack_public_path__ + "static/media/btnToggleCarousel.78e2c53225225ff3059f36db378ef08b.svg";
export { ForwardRef as ReactComponent };